import z from 'zod'

export const formSchema = z.object({
  username: z.string({
    error: (iss) =>
      iss.input === '' ? 'Please enter your username' : undefined,
  }),
  password: z
    .string()
    .min(1, 'Please enter your password')
    .min(1, 'Password must be at least 1 characters long'),
})
